import { z } from 'zod';

/////////////////////////////////////////
// BRANDED APP JOB RUNS SCHEMA
/////////////////////////////////////////

export const branded_app_job_runsSchema = z.object({
  id: z.bigint(),
  branded_app_job_id: z.bigint().nullable(),
  step: z.string().nullable(),
  error_message: z.string().nullable(),
  created_at: z.coerce.date(),
  updated_at: z.coerce.date(),
})

export type branded_app_job_runs = z.infer<typeof branded_app_job_runsSchema>

export default branded_app_job_runsSchema;
